import { render, staticRenderFns } from "./AddOrderFormular.vue?vue&type=template&id=5d8d2b74&scoped=true&"
import script from "./AddOrderFormular.vue?vue&type=script&lang=js&"
export * from "./AddOrderFormular.vue?vue&type=script&lang=js&"
import style0 from "./Formular.scss?vue&type=style&index=0&id=5d8d2b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d2b74",
  null
  
)

export default component.exports